import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import React from 'react';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import Button from './Button';
const DesktopIcon = styled(UIIcon).withConfig({
  displayName: "NextButton__DesktopIcon",
  componentId: "fr67z7-0"
})(["font-size:17px;"]);

const NextButton = (_ref) => {
  let {
    currentStep,
    isEnabled,
    onSubmit,
    buttonLabel
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["currentStep", "isEnabled", "onSubmit", "buttonLabel"]);

  return /*#__PURE__*/_jsxs(Button, Object.assign({
    className: "NextButton width-100",
    currentStep: currentStep,
    disabled: !isEnabled,
    type: "submit",
    use: "primary",
    onClick: onSubmit
  }, props, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: buttonLabel
    }), /*#__PURE__*/_jsx(DesktopIcon, {
      name: "right"
    })]
  }));
};

export default NextButton;